import get from 'lodash/get';

function hasActionOrTimerConnection(node, nodeMap, checkedNodes = new Set()) {
  if (checkedNodes.has(node.id)) return false;
  checkedNodes.add(node.id);
  
  const inputConnections = get(node, 'inputs.inputs.connections', []);
  if (inputConnections.length === 0) {
    return node.name === 'Action' || node.name === 'Timer';
  }

  return inputConnections.some(connection => {
    const inputNode = nodeMap[connection.node];
    return inputNode && hasActionOrTimerConnection(inputNode, nodeMap, checkedNodes);
  });
}

export default hasActionOrTimerConnection;